/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImageModel } from './ImageModel';
import {
    ImageModelFromJSON,
    ImageModelFromJSONTyped,
    ImageModelToJSON,
} from './ImageModel';
import type { StoreItemSummaryModel } from './StoreItemSummaryModel';
import {
    StoreItemSummaryModelFromJSON,
    StoreItemSummaryModelFromJSONTyped,
    StoreItemSummaryModelToJSON,
} from './StoreItemSummaryModel';

/**
 * コミチプラスでの単行本の詳細情報
 * @export
 * @interface StoreItemVolumeDetailModel
 */
export interface StoreItemVolumeDetailModel {
    /**
     * コミチ内で単行本に付与される一意のID
     * @type {number}
     * @memberof StoreItemVolumeDetailModel
     */
    id: number;
    /**
     * 単行本が属している場所箇所
     * * thisMonth: 今月の新刊
     * * nextMonth: 来月以降の新刊
     * * alreadyPublished: 既刊
     * @type {string}
     * @memberof StoreItemVolumeDetailModel
     */
    fromSection?: StoreItemVolumeDetailModelFromSectionEnum;
    /**
     * 単行本のタイトル
     * @type {string}
     * @memberof StoreItemVolumeDetailModel
     */
    title?: string;
    /**
     * 
     * @type {StoreItemSummaryModel}
     * @memberof StoreItemVolumeDetailModel
     */
    storeItem?: StoreItemSummaryModel;
    /**
     * 単行本のカタカナタイトル
     * @type {string}
     * @memberof StoreItemVolumeDetailModel
     */
    kanaTitle?: string;
    /**
     * 読み試しエピソードのID
     * @type {number}
     * @memberof StoreItemVolumeDetailModel
     */
    trialArticleId?: number;
    /**
     * フォローユーザに単行本情報や新着情報をメールの送信が実施済みかを管理するフラグ
     * @type {boolean}
     * @memberof StoreItemVolumeDetailModel
     */
    isMailSent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StoreItemVolumeDetailModel
     */
    isbn?: string;
    /**
     * 単行本の内容
     * @type {string}
     * @memberof StoreItemVolumeDetailModel
     */
    description?: string;
    /**
     * 単行本の概要説明タイプ
     * @type {number}
     * @memberof StoreItemVolumeDetailModel
     */
    descriptionType?: number;
    /**
     * 単行本の価格
     * @type {string}
     * @memberof StoreItemVolumeDetailModel
     */
    price?: string;
    /**
     * 単行本のサイズ
     * @type {string}
     * @memberof StoreItemVolumeDetailModel
     */
    bookSize?: string;
    /**
     * 単行本のページ数
     * @type {number}
     * @memberof StoreItemVolumeDetailModel
     */
    pageCount?: number;
    /**
     * 
     * @type {ImageModel}
     * @memberof StoreItemVolumeDetailModel
     */
    image?: ImageModel;
    /**
     * 発売日のUNIX時間
     * @type {number}
     * @memberof StoreItemVolumeDetailModel
     */
    releaseDateOn?: number;
    /**
     * 公開日のUNIX時間
     * @type {number}
     * @memberof StoreItemVolumeDetailModel
     */
    publishDateOn?: number;
    /**
     * 
     * @type {string}
     * @memberof StoreItemVolumeDetailModel
     */
    jdcn?: string;
    /**
     * 公開されているかどうかのフラグ
     * @type {boolean}
     * @memberof StoreItemVolumeDetailModel
     */
    isEnable?: boolean;
}


/**
 * @export
 */
export const StoreItemVolumeDetailModelFromSectionEnum = {
    ThisMonth: 'thisMonth',
    NextMonth: 'nextMonth',
    AlreadyPublished: 'alreadyPublished'
} as const;
export type StoreItemVolumeDetailModelFromSectionEnum = typeof StoreItemVolumeDetailModelFromSectionEnum[keyof typeof StoreItemVolumeDetailModelFromSectionEnum];


/**
 * Check if a given object implements the StoreItemVolumeDetailModel interface.
 */
export function instanceOfStoreItemVolumeDetailModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function StoreItemVolumeDetailModelFromJSON(json: any): StoreItemVolumeDetailModel {
    return StoreItemVolumeDetailModelFromJSONTyped(json, false);
}

export function StoreItemVolumeDetailModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreItemVolumeDetailModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fromSection': !exists(json, 'fromSection') ? undefined : json['fromSection'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'storeItem': !exists(json, 'storeItem') ? undefined : StoreItemSummaryModelFromJSON(json['storeItem']),
        'kanaTitle': !exists(json, 'kanaTitle') ? undefined : json['kanaTitle'],
        'trialArticleId': !exists(json, 'trialArticleId') ? undefined : json['trialArticleId'],
        'isMailSent': !exists(json, 'isMailSent') ? undefined : json['isMailSent'],
        'isbn': !exists(json, 'isbn') ? undefined : json['isbn'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'descriptionType': !exists(json, 'descriptionType') ? undefined : json['descriptionType'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'bookSize': !exists(json, 'bookSize') ? undefined : json['bookSize'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'image': !exists(json, 'image') ? undefined : ImageModelFromJSON(json['image']),
        'releaseDateOn': !exists(json, 'releaseDateOn') ? undefined : json['releaseDateOn'],
        'publishDateOn': !exists(json, 'publishDateOn') ? undefined : json['publishDateOn'],
        'jdcn': !exists(json, 'jdcn') ? undefined : json['jdcn'],
        'isEnable': !exists(json, 'isEnable') ? undefined : json['isEnable'],
    };
}

export function StoreItemVolumeDetailModelToJSON(value?: StoreItemVolumeDetailModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fromSection': value.fromSection,
        'title': value.title,
        'storeItem': StoreItemSummaryModelToJSON(value.storeItem),
        'kanaTitle': value.kanaTitle,
        'trialArticleId': value.trialArticleId,
        'isMailSent': value.isMailSent,
        'isbn': value.isbn,
        'description': value.description,
        'descriptionType': value.descriptionType,
        'price': value.price,
        'bookSize': value.bookSize,
        'pageCount': value.pageCount,
        'image': ImageModelToJSON(value.image),
        'releaseDateOn': value.releaseDateOn,
        'publishDateOn': value.publishDateOn,
        'jdcn': value.jdcn,
        'isEnable': value.isEnable,
    };
}

